/* eslint-disable react-hooks/exhaustive-deps */
import clsx from 'clsx'
import {KTIcon, toAbsoluteUrl} from '../../../helpers'
import {useLayout} from '../../core'
import {Header} from './Header'
import {Navbar} from './Navbar'
import {useNavigate} from 'react-router-dom'
import {useAuth} from 'app/modules/auth'

export function HeaderWrapper() {
  const {config, classes} = useLayout()
  const navigate = useNavigate()
  const {currentUser} = useAuth()
  const position = currentUser?.position
  if (!config.app?.header?.display) {
    return null
  }

  const handleClick = () => {
    if (
      currentUser?.roles?.includes('Lecturer') &&
      (position === 'Lecturer' || position === 'School Lecturer')
    ) {
      navigate('/dashboard')
      return
    }

    if (
      currentUser?.roles?.includes('Student') &&
      (position === 'Student' || position === 'School Student')
    ) {
      navigate('/dashboard')
      return
    }

    const sys = localStorage.getItem('system_id')
    if (!sys) return

    const systemId = Number(sys)
    if (isNaN(systemId)) return

    if (systemId === 1) navigate('/system-mgt/home')
    else if (systemId === 2) navigate('/dua/home')
    else if (systemId === 3) navigate('/dphs/home')
    else if (systemId === 5) navigate('/canteen/home')
  }

  return (
    <div id='kt_app_header' className='app-header p-none'>
      <div
        id='kt_app_header_container'
        className={clsx(
          'app-container flex-lg-grow-1',
          classes.headerContainer.join(' '),
          config.app?.header?.default?.containerClass
        )}
      >
        {config.app.sidebar?.display && (
          <>
            <div
              className='d-flex align-items-center d-lg-none ms-n2 me-2'
              title='Show sidebar menu'
            >
              <div
                className='btn btn-icon btn-active-color-primary w-35px h-35px'
                id='kt_app_sidebar_mobile_toggle'
              >
                <KTIcon iconName='abstract-14' className=' fs-1' />
              </div>
              <div className='d-flex align-items-center flex-grow-1 flex-lg-grow-0'>
                <button onClick={handleClick} className='d-lg-none btn btn-link'>
                  <img
                    alt='Logo'
                    src={toAbsoluteUrl('/media/logos/default-small.svg')}
                    className='h-30px'
                  />
                </button>
              </div>
            </div>
          </>
        )}

        {!config.app.sidebar?.display && (
          <div className='d-flex align-items-center flex-grow-1 flex-lg-grow-0'>
            <button onClick={handleClick} className='btn btn-link'>
              {config.layoutType !== 'dark-header' ? (
                <img
                  alt='Logo'
                  src={toAbsoluteUrl('/media/logo/main-logo.png')}
                  className='h-50px h-lg-50px app-sidebar-logo-default bg-white'
                />
              ) : (
                <>
                  <img
                    alt='Logo'
                    src={toAbsoluteUrl('/media/logos/default-dark.svg')}
                    className='h-20px h-lg-30px app-sidebar-logo-default theme-light-show'
                  />
                  <img
                    alt='Logo'
                    src={toAbsoluteUrl('/media/logos/default-small-dark.svg')}
                    className='h-20px h-lg-30px app-sidebar-logo-default theme-dark-show'
                  />
                </>
              )}
            </button>
          </div>
        )}

        <div
          id='kt_app_header_wrapper'
          className='d-flex align-items-stretch justify-content-between flex-lg-grow-1'
        >
          {config.app.header.default?.content === 'menu' &&
            config.app.header.default.menu?.display && (
              <div
                className='app-header-menu app-header-mobile-drawer align-items-stretch'
                data-kt-drawer='true'
                data-kt-drawer-name='app-header-menu'
                data-kt-drawer-activate='{default: true, lg: false}'
                data-kt-drawer-overlay='false'
                data-kt-drawer-width='225px'
                data-kt-drawer-direction='end'
                data-kt-drawer-toggle='#kt_app_header_menu_toggle'
                data-kt-swapper='true'
                data-kt-swapper-mode="{default: 'append', lg: 'prepend'}"
                data-kt-swapper-parent="{default: '#kt_app_body', lg: '#kt_app_header_wrapper'}"
              >
                <Header />
              </div>
            )}
          <Navbar />
        </div>
      </div>
    </div>
  )
}
